import {useEffect, useRef} from 'react';
import SubUserIcon from '@/assets/subuser-icon.svg?react';
import {LoginType} from '@/constants';
import {getInitParams, getQueryVariable} from '@/util';
import style from './index.less';

const OtherLoginTypeBar = ({loginType}: {loginType: LoginType}) => {
    const subUserLinkTarget = getQueryVariable('subUserLinkTarget') || '_self';
    const {subuserLoginLink} = getInitParams();
    const ref = useRef(null);

    useEffect(() => {
        if (loginType !== LoginType.UC) {
            const $passAuthSite = $('.tang-pass-footerBar');
            // FIXME: passport js sdk 延迟生成的三方登录的几个icon，这里不确定有没有生成
            // 所以这里通过MutationObserver监听一下
            if ($passAuthSite && $passAuthSite.length) {
                ref.current && ref.current.prepend($passAuthSite[0]);
            }
            const targetNode = $passAuthSite[0];
            const config = {attributes: true, childList: true, subtree: true};
            const callback = () => {
                $passAuthSite.find('.phoenix-btn-item').html('');
            };
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
            return () => {
                observer.disconnect();
            };
        }
    }, []);

    return (
        <>
            <div className={`${style.otherLoginSep}`}>
                <span>使用其他账号登录</span>
            </div>
            <div ref={ref} className={`bce-other-login-type-wrap ${style.otherLoginWrap}`}>
                <a className={style.subuser} href={subuserLoginLink} target={subUserLinkTarget} rel="noreferrer">
                    <SubUserIcon />
                    子用户
                </a>
            </div>
        </>
    );
};
export default OtherLoginTypeBar;
